export enum EventAction {
    CLOSED='Closed',
    CONTINUE_TO_QUEUE='Continue to Queue',
    CALLBACK='Callback',
    VOICEMAIL = 'Voicemail'
}